import { backendManagement } from "../backendPlatform";

export const getChargebacks = (args) => {
  return backendManagement.get("/chargebacks", { params: { ...args } });
};

export const getChargeback = (guid) => {
  return backendManagement.get(`/chargebacks/${guid}` );
};
